export function requiredValidationRule(value?: unknown): boolean | string {
  if (typeof value === 'boolean') return true;
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return true;
  }
  if (!value) return 'Required';
  if (!Object.keys(value).length) return 'Required';
  return true;
}

export function nonZeroPositiveDecimalRequiredValidationRule(
  value?: string | null,
): boolean | string {
  const msg = 'A positive decimal number is required';
  if (value == null) return msg;
  // TODO the value can be initially a number or even anything due to the initial data of the form
  const _value = Math.abs(parseFloat(value));
  if (
    Number.isNaN(_value) ||
    _value <= 0 ||
    // TODO
    /* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */
    value.toString().trim() !== _value.toString()
  ) {
    return msg;
  }
  return true;
}

export function emailValidationRule(value?: string | null): boolean | string {
  if (
    value !== null &&
    value !== undefined &&
    !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
  ) {
    return 'Not valid';
  }
  return true;
}

export function phoneValidationRule(value?: string | null): boolean | string {
  if (!value) return true;
  if (value.length !== 9) return 'Not valid';
  return true;
}

export function getMaxLengthValidationRule(maxLength: number) {
  return (value?: string | null): boolean | string => {
    const isSuccess = !value || value.length <= maxLength;
    return isSuccess || `Max ${maxLength} characters`;
  };
}

export function getMinLengthValidationRule(minLength: number) {
  return (value?: string | null): boolean | string => {
    const isSuccess = !value || value.length >= minLength;
    return isSuccess || `Min ${minLength} characters`;
  };
}
